import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { caseStudies } from '../data/mockData';
import { BookOpen, TrendingUp, Lightbulb } from 'lucide-react';

const InsightsPage = () => {
  const insights = [
    {
      id: 1,
      title: 'The Future of AI in Enterprise',
      category: 'Technology',
      date: 'July 15, 2025',
      excerpt: 'Exploring how artificial intelligence is reshaping enterprise operations and decision-making processes.',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop',
    },
    {
      id: 2,
      title: 'Cloud Migration Best Practices',
      category: 'Cloud',
      date: 'July 10, 2025',
      excerpt: 'A comprehensive guide to successful cloud migration strategies and common pitfalls to avoid.',
      image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&h=400&fit=crop',
    },
    {
      id: 3,
      title: 'Cybersecurity Trends 2025',
      category: 'Security',
      date: 'July 5, 2025',
      excerpt: 'Stay ahead of emerging threats with our analysis of the latest cybersecurity trends and technologies.',
      image: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=600&h=400&fit=crop',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-orange-100 via-blue-50 to-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-0.5 bg-orange-500" />
              <span className="text-gray-600 font-medium tracking-wide">Insights</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
              Insights & Case Studies
            </h1>
            <p className="text-gray-700 text-lg leading-relaxed">
              Discover our latest thoughts, industry insights, and success stories that showcase our expertise and innovation.
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white mb-12">Featured Case Studies</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {caseStudies.map((study, index) => (
              <div
                key={study.id}
                className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8"
              >
                <div className="flex items-center mb-6">
                  {index === 0 && <BookOpen className="w-8 h-8 text-orange-500" />}
                  {index === 1 && <TrendingUp className="w-8 h-8 text-green-500" />}
                  {index === 2 && <Lightbulb className="w-8 h-8 text-blue-500" />}
                </div>
                <h3 className="text-orange-400 font-semibold mb-3">Challenges</h3>
                <p className="text-gray-300 text-sm mb-6">{study.challenges}</p>
                <h3 className="text-green-400 font-semibold mb-3">Benefits</h3>
                <p className="text-gray-300 text-sm mb-6">{study.benefits}</p>
                <h3 className="text-blue-400 font-semibold mb-3">Solution</h3>
                <p className="text-gray-300 text-sm">{study.solution}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Articles */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-12">Latest Articles</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {insights.map((insight) => (
              <div
                key={insight.id}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-2xl mb-6 h-56">
                  <img
                    src={insight.image}
                    alt={insight.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-orange-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      {insight.category}
                    </span>
                  </div>
                </div>
                <p className="text-gray-500 text-sm mb-2">{insight.date}</p>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-orange-500 transition-colors">
                  {insight.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {insight.excerpt}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InsightsPage;
